import { render } from "./PollEditor.vue?vue&type=template&id=57a4a3f2&scoped=true"
import script from "./PollEditor.vue?vue&type=script&lang=js"
export * from "./PollEditor.vue?vue&type=script&lang=js"

import "./PollEditor.vue?vue&type=style&index=0&id=57a4a3f2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57a4a3f2"]])

export default __exports__